if($('html[lang="cs"]').length){
    var vyrobce = 'Výrobce:';
    var priloha = 'Příloha:';
}
else if($('html[lang="de"]').length){
    var vyrobce = 'Hersteller:';
    var priloha = 'Anhang:';
}
else if($('html[lang="pl"]').length){
    var vyrobce = 'Producent:';
    var priloha = 'Załącznik:';
}
else{
    var vyrobce = 'Manufactured:';
    var priloha = 'Attachment:';
}